import React, { memo } from 'react';
import SearchInput from './SearchInput';

interface SearchAndFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  showColumnFilters: boolean;
  onToggleFilters: () => void;
  placeholder?: string;
}

const SearchAndFilters = memo<SearchAndFiltersProps>(({ 
  searchQuery, 
  onSearchChange, 
  showColumnFilters, 
  onToggleFilters,
  placeholder = "Search contacts..."
}) => {
  return (
    <div className="flex">
      <div className="flex items-center gap-2 w-full max-w-md">
        <div className="flex-1">
          <SearchInput
            value={searchQuery}
            onChange={onSearchChange}
            placeholder={placeholder}
          />
        </div>
        <button
          onClick={onToggleFilters}
          className={`flex items-center mb-4 gap-1 px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
            showColumnFilters
              ? 'bg-blue-100 text-blue-800 border border-blue-300'
              : 'bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200'
          }`}
          aria-label="Toggle column filters"
        >
          <svg 
            className="w-4 h-4" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" 
            />
          </svg>
          <span className="hidden sm:inline">Filters</span>
        </button>
      </div>
    </div>
  );
});

SearchAndFilters.displayName = 'SearchAndFilters';

export default SearchAndFilters;
